/* eslint-disable import/no-cycle */
import React from 'react'

import { Formik, Form, FastField } from 'formik'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import * as Yup from 'yup'

import { getFlightStatus } from 'actions/flightStatus'
import { setFlightStatusSearch } from 'actions/flightStatusSearch'
import DatePickerFullResponsive from 'components/datepicker/date-picker-full-responsive'
import Input from 'components/forms/components/Input'
import { IconNames } from 'components/icons'
import { ReCaptcha } from 'components/recaptchaV2'
import theme from 'components/theme'
import { searchBox as e2eClasses } from 'constants/e2eClasses'
import FLIGHT_STATUS from 'constants/flightStatus'
import FORMATS from 'constants/formats'
import MODAL_NAMES from 'constants/modalNames'
import {
  getDateWithFormat,
  getPreviousDayFromLocalAsDate,
  getDayJsObjectFromLocal
} from 'helpers/dates'
import { getUrlParams, objectToUrlParams, buildURLEncoded } from 'helpers/url'
import { generateFlightStatusRoute } from 'helpers/url/localization'
import { handleValueChange, isMobileOrTablet, isEmpty } from 'helpers/utils'
import { mapMediaType } from 'selectors/mediaType'

import {
  Label,
  InputWrapper,
  IconWithMargin,
  Button,
  ButtonContainer,
  FormWrapper,
  Separator
} from '../styled'

class FlightNumber extends React.Component {
  constructor(props) {
    super(props)

    const { flightNumber, departureDate } = this.getUrlParameters()

    this.state = {
      values: {
        flightNumber: flightNumber || '',
        departureDate: (departureDate
          ? getDayJsObjectFromLocal(departureDate)
          : getDayJsObjectFromLocal()
        ).toDate()
      }
    }
    this.recaptchaRef = React.createRef()
  }

  componentDidMount() {
    this.pnrInputId = uuid()
  }

  getUrlParameters = () => getUrlParams(this.props.location.search.split('?').pop())

  submitForm = values => {
    const { flightNumber, departureDate: departure } = values

    const departureDate = getDateWithFormat(departure)
    const flightStatusInfo = { departureDate, flightNumber }
    const searchURL = buildURLEncoded(generateFlightStatusRoute(this.props.i18n.language), {
      ...flightStatusInfo
    })

    this.props.getFlightStatus(objectToUrlParams(flightStatusInfo))
    this.props.history.push(searchURL)
    this.props.setFlightStatusSearch(FLIGHT_STATUS.FLIGHT_NUMBER)
  }

  render() {
    return (
      <Formik
        initialValues={this.state.values}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          flightNumber: Yup.string().required(
            this.props.t('general.flight-status.search.validation.flight-number.required')
          ),
          departureDate: Yup.string().required(
            this.props.t('general.flight-status.search.validation.flight-date.required')
          )
        })}
        onSubmit={() => {
          this.recaptchaRef.current?.execute()
        }}
      >
        {props => {
          const { values } = props
          return (
            <Form onSubmit={props.handleSubmit}>
              <FormWrapper flightStatusPage={this.props.flightStatusPage}>
                <InputWrapper>
                  <Label htmlFor={this.pnrInputId} e2eClass={e2eClasses.statusFlightNumberTitle}>
                    {this.props.t('general.flight-status.search.flight-number')}
                  </Label>
                  <FastField
                    id={this.pnrInputId}
                    leftIcon={
                      <IconWithMargin
                        name={IconNames.Airplane}
                        color={theme.colors.blue}
                        size={30}
                      />
                    }
                    autoComplete="disabled"
                    name="flightNumber"
                    e2eClass={e2eClasses.statusFlightNumber}
                    onChange={e => handleValueChange(e, props)}
                    placeholder={
                      isMobileOrTablet(this.props.mediaType)
                        ? this.props.t('general.flight-status.search.flight-number-short')
                        : this.props.t('general.flight-status.search.flight-number-example')
                    }
                    error={props.touched.flightNumber && props.errors.flightNumber}
                    withPaddingError
                    boxShadow={!this.props.flightStatusPage}
                    isNumeric
                    padding={16.2}
                    component={Input}
                    maxLength={4}
                  />
                </InputWrapper>
                <Separator />
                <InputWrapper>
                  <DatePickerFullResponsive
                    name="departureDate"
                    onChange={value => handleValueChange(null, props, 'departureDate', value)}
                    disabledDays={[{ before: getPreviousDayFromLocalAsDate() }]}
                    error={props.touched.departureDate && props.errors.departureDate}
                    format={FORMATS.DAY_PICKER_FORMAT}
                    placeholder={this.props.t('general.date-picker.date-format')}
                    flatStyle={!isEmpty(this.props.flightStatusPage)}
                    modalName={MODAL_NAMES.FLIGHT_NUMBER_DATE_PICKER_MOBILE}
                    value={props.values.departureDate}
                  />
                </InputWrapper>
                <Separator />
                <ButtonContainer>
                  <Button type="submit" large>
                    {this.props.t('general.flight-status.search.submit').toUpperCase()}
                  </Button>
                </ButtonContainer>
              </FormWrapper>
              <ReCaptcha
                ref={this.recaptchaRef}
                onSuccess={() => this.submitForm(values)}
                badge="bottomleft"
              />
            </Form>
          )
        }}
      </Formik>
    )
  }
}

const mapStateToProps = state => ({
  mediaType: mapMediaType(state)
})

const mapDispatchToProps = {
  getFlightStatus,
  setFlightStatusSearch
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(FlightNumber))
)
